// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"style_skeleton__CUZrx","shine":"style_shine__gu4G7"};